import * as React from 'react';

// tslint:disable:max-line-length
export const MarketIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M15 3H4.5L4 .8C3.9.3 3.5 0 3 0H0v2h2.2L4 10.2c.1.5.5.8 1 .8h8c.4 0 .8-.3.9-.7l2-6c.2-.5-.1-1.3-.9-1.3z" />
      <circle cx="5" cy="14" r="2" />
      <circle cx="13" cy="14" r="2" />
    </g>
  </svg>
);
